<template>
  <footer class="jbl-footer" :class="(currentRouteName === 'Home') ? '' : 'jbl-footer-2'">
    <div class="container-fluid pt-3 px-0">
      <div class="container">
        <div class="row">
          <div class="col-md-3 mb-2">
            <router-link :to="{ name: 'Home' }" onclick="window.location.reload();">
              <img
                alt="Logo"
                class="img-fluid footer-logo"
                :src="require('@/assets/images/ib-logo.svg')"
              />
            </router-link>
            <h4 class="wow animate__animated animate__fadeInUp">Download Now!</h4>
            <ul class="list-inline">
              <li class="list-inline-item">
                <a href="https://apps.apple.com/us/app/insurance-bazaar/id1582637611" target="_blank">
                   <img alt="Apple Icon" class="jbl-download-app img-fluid d-none d-md-block" :src="require('@/assets/images/appstore.png')" />
<!--                  <img alt="Apple Icon" class="jbl-download-app img-fluid d-none d-md-block" :src="require('@/assets/images/appstore-coming.png')" />-->
                   <img alt="Apple Icon" class="ib-download-app img-fluid d-md-none" :src="require('@/assets/images/download-apple.svg')" />
<!--                  <img alt="Apple Icon" class="ib-download-app img-fluid d-md-none" style="position: relative; bottom: 12px;" :src="require('@/assets/images/download-apple-new.png')" />-->
                </a>
              </li>
              <li class="list-inline-item">
                <a href="https://play.google.com/store/apps/details?id=com.ozoneddigital.insuranceBazaar" target="_blank">
                  <img alt="PlayStore Icon" class="jbl-download-app img-fluid d-none d-md-block" :src="require('@/assets/images/googleplay.png')" />
                  <img alt="PlayStore Icon" class="ib-download-app img-fluid d-md-none" :src="require('@/assets/images/download-googleplay.svg')" />
                </a>
              </li>
            </ul>
            <hr class="in-dashed-hr d-none">
          </div>
          <div class="col-md-9 mb-2">
            <div class="row contact-icons wow animate__animated animate__fadeInUp">
<!--              <div class="col-md-6 col-lg-4 mb-2">-->
<!--                <div class="d-flex">-->
<!--                  <div>-->
<!--                    <img class="img-fluid" :src="require('@/assets/images/message.png')" />-->
<!--                  </div>-->
<!--                  <div>-->
<!--                    <h4 class="in-sm-title">SMS</h4>-->

<!--                    <h5>-->
<!--                      <a href="sms:8398">Insurance bazaar at 8398</a>-->
<!--                    </h5>-->
<!--                  </div>-->
<!--                </div>-->
<!--              </div>-->
              <div class="col-md-6 col-lg-3 mb-2">
                <div class="d-flex">
                  <div>
                    <img class="img-fluid" :src="require('@/assets/images/message-and-call.svg')" alt="image"/>
                  </div>
                  <div>
                    <h4 class="in-sm-title">Message &amp; CALL</h4>
                    <a class="in-flex-icon" href="tel:03000146666">
                      <div>
                        <img class="img-fluid" :src="require('@/assets/images/whatsapp-icon.svg')" style="margin-top: -11px !important;" alt="image"/>
                      </div>
                      <h5 class="in-h5-mt">0300-0146666</h5>
                    </a>
                  </div>
                </div>
              </div>
              <div class="col-md-8 col-lg-5 mb-2">
                <div class="d-flex justify-content-md-end">
                  <div>
                    <img class="img-fluid" :src="require('@/assets/images/envelop.png')" alt="image"/>
                  </div>
                  <div>
                    <h4 class="in-sm-title">FEEDBACK &amp; COMPLAINTS</h4>
                    <h5>
                      <a href="mailto:info@insurancebazaar.com.pk">info@insurancebazaar.com.pk</a>
                    </h5>
                    <h5>
                      <a href="mailto:complaints@insurancebazaar.com.pk">complaints@insurancebazaar.com.pk</a>
                    </h5>
                  </div>
                </div>
              </div>
            </div>
            <hr class="in-dashed-hr d-none">
            <div class="row wow  wow animate__animated animate__fadeInUp">
              <!-- <div class="col-md-2" style="padding-top: 1.6rem;">
                <ul class="list-unstyled custom-list jbl-footer-link">
                  <li>
                    <router-link :to="{ name: 'PrivacyPolicy'}">Privacy Policy</router-link>
                  </li>
                  <li>
                    <router-link :to="{ name: 'Terms'}">Terms of Use</router-link>
                  </li>
                  <li>
                    <router-link :to="{ name: 'FAQS'}">FAQs</router-link>
                  </li>
                </ul>
                <hr class="in-dashed-hr d-none">
              </div> -->
              <div class="col-md-12 pt-4">
                <h2 class="jbl-footer-subhead d-none d-sm-block">Quick Links</h2>
                <h2 class="jbl-footer-subhead d-block d-sm-none">Products</h2>
                <hr class="ib-border-bottom" />
                <div class="row">
                  <div class="col-lg-6 in-content-dash">
                    <h3 class="jbl-footer-subhead ib-border-bottom d-none d-sm-block">Products</h3>
                    <div class="d-flex justify-content-between mb-3 mb-md-0" >
                       <!-- v-for="mainClasses in chunkedData()" -->
                      <div  class="px-1 d-none d-md-block" v-for="mainClasses in chunkedData()">
                        <ul class="list-unstyled jbl-footer-link in-products-link">
                          <li v-for="mainClass in mainClasses">
                            <a :href="'/acquisition/' + mainClass.id">{{ mainClass.name }}</a>
                          </li>
                        </ul>
                      </div>
                      <div  class="px-1 d-md-none">
                        <ul class="list-unstyled jbl-footer-link in-products-link">
                          <li v-for="mainClass in mainClasses">
                            <a :href="'/acquisition/' + mainClass.id">{{ mainClass.name }}</a>
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div class="col-lg-2 in-content-dash">
                    <h3 class="jbl-footer-subhead ib-border-bottom">About Us</h3>
                    <ul class="list-unstyled jbl-footer-link in-overview-list">
                      <li>
                        <router-link :to="{ name: 'AboutUs'}">Overview</router-link>
                      </li>
<!--                      <li>-->
<!--                        <router-link :to="{ name: 'AboutUs'}">About Insurance Bazaar</router-link>-->
<!--                      </li>-->
<!--                      <li>-->
<!--                        <router-link :to="{ name: 'AboutUs'}">Leadership</router-link>-->
<!--                      </li>-->
                    </ul>
                  </div>
                  <div class="col-lg-4 text-lg-right">
                    <h3 class="jbl-footer-subhead">Contact Us With</h3>
                    <ul class="list-inline social-icons">
                      <li class="list-inline-item" content="Facebook" v-tippy>
                        <a href="https://www.facebook.com/InsurancebazaarPK" target="_blank">
                          <img :src="require('@/assets/images/facebook.svg')" class="img-fluid" alt="image"/>
                        </a>
                      </li>
                      <li class="list-inline-item" content="Twitter" v-tippy>
                        <a href="https://twitter.com/InsuranceBazaa1" target="_blank">
                          <img :src="require('@/assets/images/twitter.svg')" class="img-fluid" alt="image"/>
                        </a>
                      </li>
                      <li class="list-inline-item" content="Linkedin" v-tippy>
                        <a href="https://www.linkedin.com/company/insurancebazaar/" target="_blank">
                          <img :src="require('@/assets/images/linkedin.svg')" class="img-fluid" alt="image"/>
                        </a>
                      </li>
                      <li class="list-inline-item" content="Instagram" v-tippy>
                        <a href="https://www.instagram.com/insurance.bazaar/" target="_blank">
                          <i class="fa fa-instagram" style="padding-top: 1px;"></i>
                        </a>
                      </li>
                    </ul>
                    <a href="https://sdms.secp.gov.pk/" target="_blank"><img :src="require('@/assets/images/Secp-logo.bff4cf5.png')" class="img-fluid" style="margin-top: 1.3rem;"></a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row in-footer-bar">
        <div class="container">
          <div class="row">
          <div class="col-lg-4 order-2 order-md-1 jbl-footer-copyright jbl-powered-by in-default-flex">
            <div>&copy; {{ new Date().getFullYear() }} Insurance Bazaar. All Rights Reserved.</div>
          </div>
          <div class="col-lg-8 order-1 order-md-2">
            <div class="in-flow-wrap mb-4 mb-md-0">
              <div>
                <router-link :to="{ name: 'AboutUs'}">About Us</router-link>
              </div>
              <div>
                <router-link :to="{ name: 'SiteMap'}">Site Map</router-link>
              </div>
              <!-- <div>
                <router-link :to="{ name: 'Careers'}">Careers</router-link>
              </div>
              <div>
                <router-link :to="{ name: 'Team'}">Our Team</router-link>
              </div>
              <div>
                <router-link :to="{ name: 'Blog'}">Blog</router-link>
              </div> -->
              <div>
                <router-link :to="{ name: 'Legal'}">Legal &amp; Admin Policies</router-link>
              </div>
              <div>
                <router-link :to="{ name: 'ContactUs'}">Contact Us</router-link>
              </div>
            </div>
          </div>
          <!-- <div class="col-lg-6 jbl-footer-copyright jbl-powered-by jbl-powered-right" style="text-align: right;" >
            <div>
              <span style>Powered By</span>
              <img src="https://ozonedtech.com/jubilee/assets/images/powered_by_footer.svg" style="width: 28px; margin-left: 6px"/>
            </div>
          </div> -->
        </div>
        </div>
        <div class="in-powered-by">
          <a class="ib-cursor-pointer" href="https://ozoneddigital.com/" target="_blank" content="Ozoned Digital" v-tippy="{ animateFill: false, animation : 'shift-toward', followCursor : true, arrow : true, arrowType : 'round' }">
            <span>Powered By</span>
            <img :src="require('@/assets/images/powered_by_footer.svg')" style="width: 15px; margin-left: 6px" alt="Ozoned"/>
          </a>
        </div>
      </div>
    </div>
    <div class="appDownloadIcons" v-if="main_show">
      <div class="position-relative" v-if="android" style="max-width: 600px; margin: 0 auto" id="android-down-icon">
        <img @click="CloseMain" :src="require('@/assets/images/jbl-m-x-icon.png')" class="img-fluid phone-down-img" alt="Download App">
        <a href="https://play.google.com/store/apps/details?id=com.ozoneddigital.insuranceBazaar">
          <img :src="require('@/assets/images/android-app-download.png')" class="img-fluid" alt="Download Mobile App">
        </a>
      </div>
      <div @click="CloseMain" class="position-relative" v-if="apple" style="max-width: 600px; margin: 0 auto" id="apple-down-icon">
        <img :src="require('@/assets/images/jbl-m-x-icon.png')" class="img-fluid phone-down-img" alt="Download App">
        <a href="https://apps.apple.com/us/app/insurance-bazaar/id1582637611">
          <img :src="require('@/assets/images/apple-app-download.png')" class="img-fluid" alt="Download Mobile App">
        </a>
      </div>
    </div>
  </footer>
</template>

<script>
import { tippy } from "vue-tippy";

  export default {
    name: "DefaultFooter",
    data() {
      return {
        mainClasses: {},
        apple : false,
        android: false,
        main_show: true,
      };
    },
    computed: {
      currentRouteName() {
        return this.$route.name;
      }
    },
    created() {
      const self = this;
      self.getMainClasses();
      self.checkDevice();
    },
    methods: {
      CloseMain(){
        const self = this;
        self.main_show = false;
      },
      checkDevice(){
        const self = this;
        var isMobile = {
          Android: function() {
            return navigator.userAgent.match(/Android/i);
          },
          BlackBerry: function() {
            return navigator.userAgent.match(/BlackBerry/i);
          },
          iOS: function() {
            return navigator.userAgent.match(/iPhone|iPad|iPod/i);
          },
          Opera: function() {
            return navigator.userAgent.match(/Opera Mini/i);
          },
          Windows: function() {
            return navigator.userAgent.match(/IEMobile/i) || navigator.userAgent.match(/WPDesktop/i);
          },
          any: function() {
            return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
          }
        };
        if( isMobile.iOS() ) {
          self.apple = true;
        }

        if( isMobile.Android() ){
          self.android = true;
        }
      },
      chunkedData() {
        const self = this;
        return _.chunk(self.mainClasses, 4);
      },
      async getMainClasses() {
        const self = this;
        await axios
          .get("get_mainclasses")
          .then(function (resp) {
            self.showLoader = false;
            if (resp.data.code == 200) {
              self.mainClasses = resp.data.data.main_classes;
            } else {
              $toast.error(resp.data.message, { position: "top-right" });
              return false;
            }
          })
          .catch(function (error) {
            self.showLoader = false;
            error.response.data.errors.forEach((element) => {
              $toast.error(element.message, { position: "top-right" });
            });
          });
      },
    }
  };
</script>

<style scoped>
  i.fa-instagram:hover {
    color:white !important;
  }
  .in-footer-bar {
    width: 100%;
    min-height: 57px;
    margin: 40px 0 0;
    padding: 10px 17px;
    background-color: #9069bc;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .in-default-flex {
    display: flex;
    justify-content: center;
    align-items: center;
  }
  .in-flow-wrap {
    display: flex;
    /* justify-content: space-between; */
    justify-content: space-evenly;
    align-items: center;
    flex-flow: row wrap;
  }
  .in-flow-wrap {
    font-family: "Avenir Medium";
    font-size: 14px;
    font-weight: 500;
    color: white;
    opacity: 0.7;
  }
  .in-content-dash a {
    margin-left: 10px;
  }
  .in-content-dash a::before {
    content: "-";
    display: block;
    position: absolute;
    left: -10px;
    top: 0px;
  }
  @media(max-width:550px) {
    .in-flow-wrap {
      justify-content: space-around;
    }
    .in-flow-wrap div {
      margin-bottom: 17px;
      padding: 0px 5px;
    }
    .in-products-link li {
      padding-top: .6rem !important;
      padding-bottom: .6rem !important;
    }
    .in-products-link {
      margin-bottom: 0px !important;
    }
    .footer-logo {
      margin-bottom: 2rem !important;
      width: 50% !important;
    }
    .jbl-footer {
      padding-top: 1.2rem !important;
    }
    .custom-list li, .in-overview-list li {
      border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    }
    .in-footer-bar {
      margin: 10px 0 0px;
      padding-top: 20px;
    }
    .in-powered-by {
      display: flex;
      justify-content: center;
      align-items: center;
      margin-top: 16px;
      font-size: 12px;
    }
    .jbl-footer-subhead {
      width: max-content;
      padding: 5px 15px;
      border-radius: 7px;
      border: solid 1px #707070;
      background-color: rgba(255, 255, 255, 0.2);
      margin-bottom: 20px;
    }
    .ib-border-bottom {
      border-bottom: 1px solid rgba(255, 255, 255, 0.12) !important;
    }
    .jbl-footer h4, .jbl-footer-link li {
      opacity: 1 !important;
    }
    .in-sm-title {
      color: #ef7c94 !important;
    }
    .in-dashed-hr {
      width: 100%;
      border-top: 2px dashed rgba(255, 255, 255, 0.3);
      margin: 20px auto 10px;
      display: block !important;
    }
    .footer-logo {
      max-width: 150px !important;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer/DefaultFooter.vue